if (document.querySelector('.intro-landing')) {
    document.addEventListener('DOMContentLoaded', () => {
        // Sprawdź, czy na stronie jest sekcja o klasie "intro-landing"
        const introLanding = document.querySelector('.intro-landing');
        
        if (introLanding) {
            // Pobierz język strony z tagu HTML
            const lang = document.documentElement.lang;
            
            // Określ odpowiednie id na podstawie języka
            const id = lang === 'pl-PL' ? 'szczegoly' : 'details';
            
            // Znajdź wszystkie sekcje na stronie
            const sections = document.querySelectorAll('section');
            
            // Jeśli są co najmniej dwie sekcje, nadaj drugiej sekcji odpowiednie id
            if (sections.length >= 2) {
                sections[1].id = id;
            }
        }
    });
}